var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9999C14.206 15.9999 16 14.2059 16 11.9999V5.99994C16 3.78294 14.215 1.97894 12.021 1.97894C11.952 1.97894 11.881 1.98794 11.812 2.00394C9.693 2.10394 8 3.85694 8 5.99994V11.9999C8 14.2059 9.794 15.9999 12 15.9999Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.9309V21.9999H13V19.9309C16.939 19.4359 20 16.0729 20 11.9999H18C18 15.3089 15.309 17.9999 12 17.9999C8.691 17.9999 6 15.3089 6 11.9999H4C4 16.0719 7.061 19.4359 11 19.9309Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.17a831ae4f4ed1799d80b3817bb4c6bc.svg";
export { ForwardRef as ReactComponent };